<table class="table table-borderless arivis-cloud-table">
    <ng-content></ng-content>
</table>
